import React from 'react';
import { CssBaseline } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Industries from './components/Industries';
import Brands from './components/Brands';
import WhyChooseUs from './components/WhyChooseUs';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

/* Theme is now managed in context/ThemeContext.js with dark mode support */
function App() {
  return (
    <ThemeProvider>
      <CssBaseline />
      <Helmet>
        <title>Al Amoudi Bearing | Auto Parts, Bearings, Oil Seals & Industrial Equipment in Saudi Arabia</title>
        <meta name="description" content="Al Amoudi Bearing - Your trusted supplier for Auto Parts, Tools, Oil Seals, Belts, Spare Parts & Industrial Equipment in Riyadh and Dammam, Saudi Arabia." />
      </Helmet>
      <Navbar />
      <main>
        <Hero />
        <About />
        <Products />
        <Industries />
        <Brands />
        <WhyChooseUs />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </ThemeProvider>
  );
}

export default App;
